module.exports = __webpack_public_path__ + "assets/img/thumb-Kitome-Blog.8e1368f9.jpg";